import { ArrowPathIcon } from '@heroicons/react/24/outline';
import Modal from 'Components/Common/Modal/NewModal';
import useThemeStore from 'Theme/store';

/**
 * Warning modal for when users try to change model selection on older responses.
 * Explains that this will break conversation flow tracking.
 */
const ConversationPathWarning = ({ open, onClose, onConfirm }) => {
  const { theme } = useThemeStore();

  return (
    <Modal onClose={onClose} open={open} title="Change conversation path">
      <>
        <div className="font-figtree text-base text-black dark:text-crystal-bell text-center">
          <div className="mb-2">
            Changing the model selection on a previous response will alter your
            conversation path. You won't be able to track the original
            selections that led to your current conversation state.
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400 mt-3">
            Your next message will use this new selection as the foundation for
            the next AI's response, replacing the original conversation flow.
          </div>
        </div>

        {/* Custom button layout */}
        <div className="flex w-full gap-3 items-center justify-center mt-6">
          {/* Cancel/Back off button */}
          <button
            onClick={onClose}
            className={`flex items-center justify-center text-[16px] leading-6 font-semibold rounded-xl px-4 py-2 border transition-colors ${
              theme === 'dark'
                ? 'bg-gray-700 text-gray-300 border-gray-700 hover:bg-gray-600'
                : 'bg-white text-gray-700 border-shadow-gray hover:bg-gray-100'
            }`}
          >
            Cancel
          </button>

          {/* Confirm button */}
          <button
            onClick={onConfirm}
            className="flex gap-2 items-center justify-center text-[16px] leading-6 font-semibold rounded-xl px-4 py-2 text-white focus:outline-none bg-nue-blue hover:bg-nue-blue/70 transition-colors"
          >
            <ArrowPathIcon className="h-[18px] w-[18px]" aria-hidden="true" />
            Change Selection
          </button>
        </div>
      </>
    </Modal>
  );
};

export { ConversationPathWarning };
